export default __webpack_public_path__ + "static/media/logo-hpe-on-light-horizontal.abdc16f6.svg";